// ----
// JS for MarcRecords Widget
// ----

var SCM = SCM || {};
var App = App || {};

App.MarcRecords = (function ($) {

    var $instSelect;
    var $dateRangeBtn;
    var $dateRangeInputs;

    return {
        init: init
    };

    // returns true if the feature is enabled, false otherwise
    function init() {
        $instSelect =  $('#institution-select');
        $dateRangeBtn = $('.js-marc-records-date-range-button');
        $dateRangeInputs = $('.js-marc-records-date-range');
        
        $dateRangeInputs.hide();
        
        // do not continue if the feature is not enabled
        if ($dateRangeBtn.length) {

            // Institution Selector
            if ($instSelect.length) {
                
                $instSelect.on('change', function() {
                    $('.js-institution-wrap').hide(); // hide all institution info
                    $('.js-institution-' + $(this).val()).show(); // show selected institution info
                });
                
            }
            
            
            // Radio Buttons
            // Toggle date range filter visibility
            $('.js-marc-records-radio-button').change(function() {
                if ($(this).val() === 'daterange') {
                    $dateRangeInputs.show();
                } else {
                    $dateRangeInputs.hide();
                }
            });
            
            
            // Date Range Button Download
            $dateRangeBtn.on('click', function() {
               var instId = $(this).data('institution-id');
               // get the value of the selected date rage
               var option = $(this).parent().find('.js-marc-records-radio-button:checked').val();
               var startDate = ""
               var endDate = "";
               
               if (option === 'daterange') {
                   // validate the date range
                   var $fromDiv = $(this).parent().find('.js-marc-records-date-range-from');
                   var $toDiv = $(this).parent().find('.js-marc-records-date-range-to');

                   var dateInfos = validateAndReturnDates($fromDiv, $toDiv);
                   if (!dateInfos.Success) {
                       $('.js-error-message').html(dateInfos.ErrorMessage).show();
                       return;
                   }
                   
                   startDate = dateInfos.FromDate;
                   endDate = dateInfos.ToDate;
               }
               
               var data = {
                   "institutionId": instId,
                   "option": option,
                   "startDate": startDate,
                   "endDate": endDate
               };

               // clear any previous error messages
               $('.js-error-message').html('').hide();

                SCM.Ajax.post($(this).data('url'), data)
                    .expectJson()
                    .then(function (result) {
                        
                        if (result.Success) {
                            $('.js-error-message').html('').hide();
                            window.location.href = result.DownloadUrl;    
                        }
                        else {
                            $('.js-error-message').html(result.Error).show();    
                        }
                        
                    })
                    .catch(function () {
                        $('.js-error-message').html("There was an Error.  Please try again.").show();
                    });
            });
            
            return true;
        }

        return false;
    }
    
    /**
     *
     * @param {Object} $fromDiv - JqueryObject containing 'from' year and month inputs.
     * @param {Object} $toDiv - JqueryObject containing 'to' year and month inputs.
     *
     * @returns {Object} Returns an object with the following properties:
     *     - Success: bool
     *     - ErrorMessage: string 
     *     - FromDate: Date object. This is the first day of the selected 'from' month.
     *     - ToDate: Date object. This is the last day of the selected 'to' month.
     */
    function validateAndReturnDates($fromDiv, $toDiv) {
        
        var fromYear = $fromDiv.find('input').val();
        var fromMonth = $fromDiv.find('select').val();
        var toYear = $toDiv.find('input').val();
        var toMonth = $toDiv.find('select').val();
        
        var success = true;
        var errorMessage = "";
        
        // Check for missing year
        if ((!fromYear && fromMonth) || (!toYear && toMonth)) {
            errorMessage = "The month cannot be submitted without a year.";
            success = false;
        }
        
        // Check for invalid year
        if ((fromYear && fromYear.length !== 4) ||
            (toYear && toYear.length !== 4) ||
            (fromYear && isNaN(fromYear)) || 
            (toYear && isNaN(toYear))){
            errorMessage = "The year must be submitted as 4 digits (yyyy).";
            success = false;
        }
        
        // Check that at least one year is filled out
        if (!fromYear && !toYear) {
            errorMessage = "You must fill out either a From year or a To year.";
            success = false;
        }
        
        // if from year but no to year, set the to year to the present year
        if (fromYear && !toYear) {
            toYear = new Date().getFullYear();
        }
        
        // if to year but no from year, set the from year to the earliest year
        if (!fromYear && toYear) {
            fromYear = 1800;
        }

        // Default months if not selected
        fromMonth = parseInt(fromMonth) || '1';
        toMonth = parseInt(toMonth) || '12';

        // Check if from date precedes to date
        if (fromYear > toYear || (fromYear === toYear && fromMonth > toMonth)) {
            errorMessage = "The From date must precede the To date.";
            success = false;
        }
        
        
        // FromDate is the beginning of the selected month
        // ToDate is the end of the selected month
        return {
            Success: success,
            ErrorMessage: errorMessage,
            FromDate: new Date(fromYear, fromMonth - 1, 1),
            ToDate: new Date(toYear, toMonth, 0)
        }
    }
    
})(jQuery);

jQuery(function () {
    App.MarcRecords.init();
});